import React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Card from "react-bootstrap/Card"
import CardGroup from "react-bootstrap/CardGroup"
import { Link } from "gatsby"
import Reveal from "react-reveal/Reveal"
import Img from "gatsby-image"
import "./cards.scss"
import { useStaticQuery, graphql } from "gatsby"

const MyCard = () => {
  const data = useStaticQuery(
    graphql`
      query {
        computerImg: file(relativePath: { eq: "computer.jpg" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )
  return (
    <section>
      <Row className="mx-0  mb-md-4 mb-xl-4 mb-lg-4">
        <Col
          xs={12}
          sm={12}
          md={12}
          lg={9}
          xl={9}
          className="mx-auto m-auto px-0"
        >
          <CardGroup className="mb-xl-4 mb-lg-4 mb-md-4">
            <Card className="lastCard mx-auto pnlBorder">
              <Img
                className="card.img customCardImg"
                variant="top"
                fluid={data.computerImg.childImageSharp.fluid}
              />
              <Card.Body className="panelBg">
                <Card.Title>
                  <h2
                    className="text-center text-black-50"
                    style={{ lineHeight: 1.2, fontSize: "1.75rem" }}
                  >
                    Prototyping and development
                  </h2>
                </Card.Title>
                <Reveal bottom forever={true}>
                  <Card.Text className="mx-auto">
                    I can desing quick prototypes for approval. Create
                    attractive, fullstack applications using Node.js, Express,
                    React, Redux and MongoDB along with ES6+
                  </Card.Text>
                </Reveal>

                <hr className="mx-0 mt-0 bg-secondary" />
                <Link
                  to="/Blog"
                  className="float-right text-secondary"
                  type="button"
                >
                  <abbr title="Blog Link" className="customLink">
                    Read More
                  </abbr>
                  <span className="text-danger">
                    <strong> &#62;</strong>
                  </span>
                </Link>
              </Card.Body>
            </Card>
          </CardGroup>
        </Col>
      </Row>
    </section>
  )
}
export default MyCard
